import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { withRouter } from "react-router-dom";
import uuid from 'uuid/v1';
import moment from 'moment';
import  Page  from '../../components/Page';
import {  UserFilter } from '../../components';
import { NetworkContext } from '../../context/NetworkContext';
import { SnackBarContext } from "../../context/SnackbarContext";

import { Header, Results, UserDetails } from './components';
import SubscriptionDetails from './components/SubscriptionDetails';
import { hasPermission } from '../../utils/permissions';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    padding: theme.spacing(3)
  },
  results: {
    marginTop: theme.spacing(3)
  }
}));
export const EditUser = withRouter(props => {

  const classes = useStyles();
  const [userobj, setUserobj] = useState(null);
  const [userid, setUserid] = useState('');
  const [viewtype, setViewtype] = useState(1);
  const snackbarCtx = React.useContext(SnackBarContext);

  const [masters, setMasters] = useState({
    "commodity":[],
    "versions":[]
  });

  const { sendNetworkRequest } = React.useContext(NetworkContext);
  
  async function fetchmasters()
  {
    let commodities = await sendNetworkRequest('/admin/getparentcommodity', {}, {},false)
    let usertypes = await sendNetworkRequest('/admin/fetchusertype', {}, {},false)
    let versions = await sendNetworkRequest('/admin/fetchversionmaster', {}, {},false)
    let languages = await sendNetworkRequest('/admin/fetchmasterlanguage', {}, {},false)

    let master_commodities = []
    let master_versions = []
    let master_languages = []

    let comm =  commodities?.module
    comm.map((item,index) => {
      master_commodities.push( {
        value : item?.id,
        label : item?.name
      })
    })

    languages.map((item,index) => {
      master_languages.push( {
        value : item?.id,
        label : item?.name
      })
    })

    versions.map((item,index) => {
      master_versions.push( {
        value : item?.id,
        label : item?.version
      })
    })

    setMasters({
      ...masters,
       versions : master_versions,
       commodity : master_commodities,
       languages : master_languages,
      usertypes : usertypes
    })
  }
async function fetchuserdetails(userid)
{
  let userdetails = await sendNetworkRequest('/admin/fetchuserdetails', {}, {userid},false)
  let platformobj = {}
  let versionobj = {}
  let commodities = []
  if(userdetails.platform)
  {
    platformobj = {
      value : userdetails.platform,
      label : userdetails.platform
    }
    userdetails['platform'] = platformobj
  }
  if(userdetails.version)
  {
    versionobj = {
      value : userdetails.version,
      label : userdetails.version
    }
    userdetails['version'] = versionobj
  }
  if(userdetails.preferredlang_id)
  {
    userdetails['language'] = {
      value : userdetails.preferredlang_id,
      label : userdetails.preferredlang
    }
  }

  if(userdetails.master_usertype || userdetails.master_usertypes)
  {
    userdetails['user_type'] = userdetails.master_usertype || userdetails.master_usertypes
  }
  if(userdetails.commodities)
  {
    let commodity_arr = userdetails.commodities;
    // commodity_arr.forEach(element => {
    //   let commodity_obj = {
    //     value : element.commodityID,
    //     label : element.commodity.name
    //   }
    //   commodities.push(commodity_obj)
    // });
    userdetails['user_commodity'] = commodity_arr
  }

  setUserobj(userdetails)
}
async function updateuserdetails(userobj)
{
  
console.log("XXXX",JSON.stringify(userobj))



  let updateuserdetails = await sendNetworkRequest('/admin/updateuserprofile', {}, userobj,false)
  snackbarCtx.setSnack({
    ...snackbarCtx,
    open: true,
    type: updateuserdetails.status,
    msg: updateuserdetails.message,
    vertical: "top",
  });
}
async function sendTestPush() {
  if (!userobj?.id) {
    return;
  }
  const result = await sendNetworkRequest('/admin/sendtestpush', {}, {
    user_profile_id: userobj.id,
    mobilenumber: userobj.mobilenumber,
    title: 'Mookambika Test',
    body: 'Test push from admin panel',
    type: '5',
    itemId: '0',
  }, false);

  snackbarCtx.setSnack({
    ...snackbarCtx,
    open: true,
    type: result?.status === 'success' || result?.statusCode === 200 ? 'success' : 'error',
    msg: result?.message || 'Failed to send test push',
    vertical: 'top',
  });
}
  useEffect(() => {
    fetchmasters()
    var user_id = props.location.pathname.split('/')[2];
    var viewtype = props.location.pathname.split('/')[3];
    setViewtype(viewtype)
     setUserid(user_id)
     fetchuserdetails(user_id);

  }, []);

  return (
    <Page
      className={classes.root}
      title="Commodity"
    >
      <Header  usercontent={userobj}/>
     {(userobj && masters.usertypes && masters.languages &&  masters.usertypes) && <UserDetails  masters={masters}  onUpdate={updateuserdetails} onSendTestPush={sendTestPush} usercontent={userobj} viewtype={viewtype}/> }
     {userid && hasPermission('subscription_users') && <SubscriptionDetails userid={userid} viewtype={viewtype} />}
     
    </Page>
  );
});

export default EditUser;
